export default __webpack_public_path__ + "static/media/seen_icon.d1890a9a.svg";